<div class="form-group mb-3" [formGroup]="parentForm">
  <div class="text-box">
    <label *ngIf="label" [for]="id" [class]="labelClass" class="form-label">{{
      label
    }}</label>
    <div [class.input-group]="clearButton || buttonClick$.observers.length">
      <input
        [id]="id"
        [type]="type"
        class="form-control"
        [formControlName]="formControlProp ?? null"
        [placeholder]="placeholder || ''"
        [class.is-invalid]="invalid"
      />

      <button
        type="button"
        class="btn bg-transparent clear"
        *ngIf="
          clearButton &&
          formControlProp != null &&
          parentForm.controls[formControlProp].value
        "
        (click)="clear()"
      >
        <i class="fal fa-times-circle"></i>
      </button>

      <button
        class="btn btn-primary"
        type="button"
        [disabled]="buttonDisabled || loading"
        (click)="buttonClick()"
        *ngIf="buttonClick$.observers.length && buttonText"
      >
        <i class="fal fa-sync fa-spin ms-0" *ngIf="loading"></i>
        <ng-container *ngIf="!loading">{{ buttonText }}</ng-container>
      </button>
    </div>
    <ng-content select="[typeahead-list]"></ng-content>
  </div>
  <div class="content mt-1">
    <ng-content></ng-content>
  </div>
</div>
